import { ViewerLoadingProgress } from "@/hooks/viewer/use-viewer";

interface ViewerLoadingProps {
    progress: ViewerLoadingProgress;
    loadingText?: string;
}

const ViewerLoading = ({ progress, loadingText }: ViewerLoadingProps) => {
    const { phase, completed, total, failed } = progress;
    let title = loadingText ?? "Chargement des fichiers…";
    let detail = `${completed} / ${total} fichiers chargés`;

    if (phase === "initialising") {
        title = "Initialisation de la visionneuse…";
        detail = "Veuillez patienter…";
    } else if (phase === "preparing") {
        title = "Préparation de l’affichage…";
        detail = "Veuillez patienter…";
    }

    return (
        <div className="absolute inset-0 z-20 grid cursor-wait place-items-center bg-[#e4ede9]/95 p-4 text-[0.8125rem] leading-normal text-slate-700">
            <div className="w-full max-w-[22rem] rounded-lg border border-slate-300 bg-white p-4 shadow-md" role="status" aria-live="polite" aria-atomic="true">
                <p className="mb-3 font-semibold">{title}</p>
                <progress
                    className="block h-2 w-full accent-[#286fb7]"
                    aria-label="Chargement de la visionneuse"
                    max={total || 1}
                    value={phase === "loading" ? completed + failed : undefined}
                />
                <p className="mt-2 text-slate-500">{detail}</p>
                {failed > 0 && (
                    <p className="mt-2 text-red-700">
                        {failed === 1 ? "Un fichier n’a pas pu être chargé." : `${failed} fichiers n’ont pas pu être chargés.`}
                    </p>
                )}
            </div>
        </div>
    );
};

export default ViewerLoading;
